import { useEffect, useState } from "react";
import { getTopper } from "../Service/Api";
import LazyLoad from "react-lazyload";
import Slider from "react-slick";

const getSessionYearLabel = (endYear) => `${endYear - 1}-${endYear}`;

const TopperX = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const topperData1 = await getTopper();

        const topperData = Array.isArray(topperData1)
          ? topperData1.sort(
              (a, b) => parseFloat(b.division) - parseFloat(a.division)
            )
          : [];

        const classXData = topperData.filter(
          (item) => item.class === "X"
        );

        let year = new Date().getFullYear();
        let matchedData = [];

        // Try current session first, then previous sessions
        while (year >= 2000 && matchedData.length === 0) {
          const targetSessionYear = getSessionYearLabel(year);

          matchedData = classXData.filter(
            (item) => item.sessionYear === targetSessionYear
          );

          if (matchedData.length === 0) {
            year -= 1;
          }
        }

        setData(matchedData);
      } catch (error) {
        console.error("Error fetching topper data:", error);
      }
    };

    fetchData();
  }, []);

  const emptyArray = [
    {
      name: "Student Name",
      per: "90%",
    },
    {
      name: "Student Name",
      per: "90%",
    },
  ];

  const sortedData = data
    .slice()
    .sort((a, b) => parseFloat(b.division) - parseFloat(a.division));

  const displayData = sortedData.length > 0 ? sortedData : emptyArray;

  const settings = {
    autoplay: true,
    infinite: displayData.length > 1,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    pauseOnHover: true,

    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <Slider {...settings}>
        {displayData.map((item, index) => (
          <div
            className="item px-2"
            key={`${item._id || item.name}-${index}`}
          >
            <div className="topperdiv">
              <div className="star">
                {item.division ? `${item.division}` : item.per}
              </div>

              <div className="toppertaj">
                <LazyLoad
                  offset={10}
                  placeholder={
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/dummy.jpg"
                      alt="Loading..."
                      className="img-fluid"
                    />
                  }
                >
                  <img
                    src={
                      item.attachments && item.attachments[0]
                        ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`
                        : "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/dummy.jpg"
                    }
                    alt={item.name || "Student"}
                    className="img-fluid"
                  />
                </LazyLoad>
              </div>

              <div className="topperdesc">
                <p className="name">{item.name}</p>

                {/* {data.length > 0 &&
                  index === 0 && (
                    <p>School Topper</p>
                  )} */}

                <p>{item.stream}</p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </>
  );
};

export default TopperX;
